import { fieldValidationMessages } from 'app/constants';

export interface PasswordChangeFormData {
  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
}

export const errorMessages = {
  errors: {
    currentPassword: {
      required: fieldValidationMessages.CURRENT_PASSWORD,
      minLength: fieldValidationMessages.MIN_PASSWORD,
    },
    newPassword: {
      required: fieldValidationMessages.REQUIRED_PASSWORD,
      minLength: fieldValidationMessages.MIN_PASSWORD,
      pattern: fieldValidationMessages.WEAK_PASSWORD,
    },
    newPasswordRepeat: {
      required: fieldValidationMessages.PASSWORD_REPEAT,
      match: fieldValidationMessages.PASSWORD_MATCH,
    },
  },
};
